export default __webpack_public_path__ + "static/media/glovo.d30594ee.png";